<template>
  <div class="Notification" :class="{ 'Notification--Active': ready }">
    <span class="js-pdp-notification-icon">
      <Icon icon="free-shipping" />
    </span>
    <span class="js-pdp-notification-msg t5" ref="message"></span>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Icon from '../Global/Icon.vue';

const ready = ref(false);
const message = ref(null);

const observeHandler = () => {
  const element = message?.value ?? false;
  if (!element) return;

  const hasText = element.textContent.length > 0;
  setTimeout(() => (ready.value = hasText), 250);
};

document.addEventListener('dy:pdp:notification:set', observeHandler);
</script>
